import formatPhoneForDisplay from './formatPhoneForDisplay';

function convertPhoneNumber(phoneNumber, phonePrefixed) {
  if (phoneNumber == null || phoneNumber === '') return phoneNumber;
  if (typeof phoneNumber === 'string' && phoneNumber.includes('+') && !phonePrefixed) {
    return phoneNumber;
  }
  return formatPhoneForDisplay(phoneNumber, phonePrefixed);
}

export default convertPhoneNumber;
